module.exports = __webpack_public_path__ + "static/enbridge-34ef91da37473947fcaaa976bec54221.jpg";